export default __webpack_public_path__ + "static/e_rublack-ef9de0a7dd82b3e75d50a78e82172420.jpg";